import React, { useEffect, useRef } from 'react';
// @ts-ignore
import { CSVLink } from 'react-csv';
import { download } from '../utils/download';

interface CsvProps {
  filename: string;
  headers?: string[];
  date: string;
  data?: any[];
}

export default function CsvExport({ filename, headers, data, date }: CsvProps) {
  const csvRef = useRef<any>(null);

  useEffect(() => {
    function downloadCsv() {
      download(csvRef.current.buildURI(data), `Pins_${date}.csv`);
    }
    downloadCsv();
  }, [data, date]);

  return (
    <CSVLink
      ref={csvRef}
      filename={`${filename}.csv`}
      headers={headers}
      data={data}
    />
  );
}
